import { TweenLite, Power2 } from 'gsap/TweenMax'
require('gsap/ScrollToPlugin')

export default {
  name: 'my-scroll',
  render: function (createElement) {
    const tag = this.id === 0 ? 'button' : 'a'
    return createElement(
      tag, {
        'class': {
          'c-menu__link': this.isMenu,
          'c-menu__link--is-active': this.isActiveMenu
        },
        on: {
          click: this.myScrollTo
        }
      },
      this.$slots.default
    )
  },
  props: {
    isMenu: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      id: 0
    }
  },
  computed: {
    offsetY () {
      return (this.$store.state.device !== 2) ? 60 : 0
    },
    isActiveMenu () {
      return (this.id !== 0 && this.isMenu && this.$store.state.currentSection === this.id.replace('#', ''))
    }
  },
  methods: {
    myScrollTo (e) {
      const url = (this.id === 0) ? window.location.pathname : this.id
      e.preventDefault()

      if (this.$store.state.device !== 2) {
        this.$store.commit('setMenu', false)
      }

      TweenLite.to(window, 0.5, {
        ease: Power2.easeOut,
        scrollTo: {
          y: this.id,
          autoKill: false,
          offsetY: this.offsetY
        }
      })

      if (window.history && window.history.pushState && this.id !== false) {
        history.pushState('', document.title, url)
        window.gtag('event', 'menu_clicked', { 'event_label': url })
      }
    }
  },
  mounted () {
    this.id = this.$el.getAttribute('href') || 0
  }
}



// WEBPACK FOOTER //
// ./src/components/standard/my-scroll.js